export default __webpack_public_path__ + "static/media/hello-coin.350948cf.svg";